export const iconFontAwesomeMedicalHealthDroplet = (
	<i className="fa-solid fa-droplet"></i>
);
